define(['moduler'], function (Moduler) {
    'use strict';

    /*
        Example HTML:

        <div class="js-products">
            <!-- list products for page one. -->
        </div>

        <p>
            <a href="?page=2" data-module="LoadMore" data-load-more="url: '/api/products', contentElement: '.js-products'">Load results {from}-{to}</a>
        </p>
    */

    return Moduler.create({
        defaults: {
            url: null,
            method: 'GET',
            event: 'click',
            data: null, /* extra data to send along the request to server */
            contentElement: null, /* selector for element where content should be appended or replaced */
            page: 1, /* the page currently on */
            insertMode: 'append', /* append|replace|replacefirstpage */
            loadingCssClass: 'is-loading',
            pageSize: null, // size of each page, used when displaying page range in button. ("Results from 11-20")
            removeSelf: false,
            visibleClass: null,// if a class should be used for button visiblity, set it here, otherwise style.display block/none is used
            lastPageHeader: 'X-LastPage' // name of the last page header, set it to something unique if there are more then one loadmore module on a page
        },

        init: function () {
            var self = this;

            if (!self.options.url) {
                if (self.el.matches('a[href]')) {
                    self.options.url = self.el.getAttribute('href');
                } else {
                    self.options.url = window.location.href;
                }
            }

            // save a reference to contentElement
            self.contentElement = document.querySelector(self.options.contentElement) ?? self.el;

            self.el.addEventListener(self.options.event, function (e) {
                e.data = self;
                self.loadMore(e);
            });

            self.el.addEventListener('loadFirstPage', function (e) { 
                e.data = self;
                self.loadFirstPage(e);
            });

            self.el.addEventListener('loadMore', function (e) {
                e.data = self;
                self.loadMore(e);
            });

            var linkHtml = self.el.innerHTML;
            var shouldDisplayPageRange = linkHtml.indexOf('{from}') != -1;

            if (shouldDisplayPageRange) {
                self.shouldDisplayPageRange = true;
                self.linkHtml = linkHtml;

                self.updateLinkText();
            }
        },

        loadPage: function () {
            var self = this;
            self.el.classList.add(self.options.loadingCssClass);
            self.isLoading = true;
            self.el.dispatchEvent(new CustomEvent('load-more-start'));

            var data = {
                partial: true,
                page: self.options.page,
                loadingMore: true,
                lastPageHeader: self.options.lastPageHeader
            };
            var extraData = {};
            if (self.el.getAttribute('data-extradata')) {
                extraData = JSON.parse(self.el.getAttribute('data-extradata'));
            }
            Object.assign(data, self.options.data, extraData);

            var url = self.options.url.replace('{page}', self.options.page);

            var opts = {
                method: self.options.method.toUpperCase()
            };
            if (opts.method == 'POST') {
                var formData = new FormData();
                for ( var key in data) {
                    formData.append(key, data[key]);
                }
                opts.body = formData;
            } else {
                var params = new URLSearchParams();
                Object.keys(data).forEach(key => params.append(key, data[key]));
                if (params.toString().length > 0) {
                    var delim = url.indexOf('?') > -1 ? '&' : '?';
                    url += delim + params.toString();
                }
            }

            return fetch(url, opts)
                .then(response => {
                    self.isLoading = false;
                    if (self.options.removeSelf) {
                        self.el.parentNode.removeChild(self.el);
                    } else {
                        self.el.classList.remove(self.options.loadingCssClass);
                    }

                    if (response.status != 200) {
                        self.el.dispatchEvent(new CustomEvent('load-more-error'));
                    } else {
                        response.text().then(function (text) {
                            if (self.options.insertMode == 'replace') {
                                self.contentElement.innerHTML = text;
                            } else if (self.options.insertMode == 'append') {
                                self.contentElement.innerHTML += text;
                            } else if (self.options.insertMode == 'replacefirstpage') {
                                if (self.options.page == 1) {
                                    self.contentElement.innerHTML = text;
                                } else {
                                    self.contentElement.innerHTML += text;
                                }
                            }

                            Moduler.loadModules(self.contentElement);

                            if (response.headers.get(self.options.lastPageHeader)) {
                                // hide the load more button instead of removing it so that other modules can still trigger events
                                if (self.options.visibleClass) {
                                    self.el.classList.remove(self.options.visibleClass);
                                } else {
                                    self.displaySetting = self.el.style.display;
                                    self.el.style.display = 'none';
                                }
                            }

                            if (self.shouldDisplayPageRange) {
                                self.updateLinkText();
                            }

                            self.el.dispatchEvent(new CustomEvent('load-more-done', { detail: { response: text } }));
                        });
                    }
                });
        },

        updateLinkText: function () {
            var self = this;
            var from = (self.options.page * self.options.pageSize);
            var newLinkText = self.linkHtml
                .replace('{from}', from + 1)
                .replace('{to}', from + self.options.pageSize);

            self.el.innerHTML = newLinkText;
        },

        //event
        loadFirstPage: function (e) {
            var self = e.data;

            self.options.page = 1;

            if (self.options.visibleClass) {
                self.el.classList.add(self.options.visibleClass);
            } else {
                self.el.style.display = self.displaySetting ?? 'block';
                self.displaySetting = null;
            }          
            if (self.options.insertMode != 'replacefirstpage') {
                while(self.contentElement.firstChild) self.contentElement.removeChild(self.contentElement.firstChild);
            }

            self.loadPage.call(self);
        },

        //event
        loadMore: function (e) {
            e.preventDefault();
            var self = e.data;

            // prevent additional requests when user spam-clicks
            if (self.isLoading) {
                return;
            }

            // increase page by one
            self.options.page += 1;
            self.loadPage.call(self);
        }
    });
});